import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const scrollToSection = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, params);
  }
};

export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="44" height="44" rx="10" fill="#0B0F17" stroke="rgba(255,255,255,0.12)" />
    <path d="M12 14L22 24L32 14" stroke="#E63946" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 24V32" stroke="#F1FAEE" strokeWidth="3.5" strokeLinecap="round" />
    <circle cx="22" cy="12" r="2" fill="#FFB703" />
  </svg>
);
